import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

function Detail() {
    const { id } = useParams();
    console.log(id);
    const [one_movie, setOne_movie] = useState([]);
    const getMovies = async () => {
        const json = await (
            await fetch(
                `https://yts.mx/api/v2/movie_details.json?movie_id=${id}`
            )
        ).json();
        console.log(json);
        setOne_movie(json.data.movie);
    }
    useEffect(() => {
        getMovies();
    }, [])

    return (
        <div>

            <h1>Detail</h1>
            <h2>Post</h2>
            <img src={one_movie.medium_cover_image} />
            <h2>{one_movie.title}({one_movie.year}) - ({one_movie.rating})</h2>
            <h2>Intro</h2>
            <p>{one_movie.description_intro}</p>
            <h2>Genres</h2>
            <ul>
                {one_movie.genres?.map((g) => (
                    <li key={g}>{g}</li>
                ))}
            </ul>
        </div>



    )
}

export default Detail;